import React from 'react';
import { Row, Col, Alert, Button, Checkbox } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class FittingBatchEditComponent extends React.Component {

	componentDidMount() {
		this.props.findAllFirefighterTypes();
	}

	render() {
		return (
			<div>
          		<Row>
          			<Col xs={2} sm={2} md={2}>
				      	<Button onClick={this.props.addBatchItems} bsStyle="info">
					      Submit
					    </Button>
				    </Col>
				    <Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
				    </Col>
			    </Row>
			    <br />
			    <Row>
			        <Col xs={12} sm={12} md={12}>
			        <label className="control-label" style={{marginBottom: 20}}>訂單編號: {this.props.batch.get('orderId')}</label>
		            <DropDownInput id="firefighterType"
		                label="警義消別"
						required="true"
		                options={this.props.allFirefighterTypes.map((value, key) => ({label:value.get('display_name'), value:value.get('firefighter_type')})).toJS()}
		                selected={[{label: this.props.batch.get('displayName'), value:this.props.batch.get('firefighterType')}]}
		                onChange={(id, value, label) => {
		                    this.props.setValue(id, value);
		                    this.props.setValue('displayName', label);
		                    this.props.setValue('category', label);
		                }}
		                validation={this.props.batchValidation.get('firefighterType')}
		            />
				    <FieldGroup
				      id="category"
				      type="text"
				      label="群組 (統計報表使用，預設為警義消別)"
				      value={this.props.batch.get('category')}
				      placeholder=""
					  required="true"
	                  onChange={(id, value) => {
	                      this.props.setValue(id, value);
	                  }}
	                  validation={this.props.batchValidation.get('category')}
				    />
				    <FieldGroup
				      id="firefighterCorporation"
				      type="text"
				      label="單位"
				      value={this.props.batch.get('firefighterCorporation')}
				      placeholder=""
	                  onChange={(id, value) => {
	                      this.props.setValue(id, value);
	                  }}
	                  validation={this.props.batchValidation.get('firefighterCorporation')}
				    />
				    <FieldGroup
				      id="firefighterDivision"
				      type="text"
				      label="大隊"
				      value={this.props.batch.get('firefighterDivision')}
				      placeholder=""
	                  onChange={(id, value) => {
	                      this.props.setValue(id, value);
	                  }}
	                  validation={this.props.batchValidation.get('firefighterDivision')}
				    />
				    <FieldGroup
				      id="firefighterSquadron"
				      type="text"
				      label="分隊"
				      value={this.props.batch.get('firefighterSquadron')}
				      placeholder=""
	                  onChange={(id, value) => {
	                      this.props.setValue(id, value);
	                  }}
	                  validation={this.props.batchValidation.get('firefighterSquadron')}
				    />
					<Checkbox checked={this.props.batch.get('isSpareParts')} onClick={this.props.clickIsSpareParts}>
                    	是否為備品
                	</Checkbox>
		            <DropDownInput id="orderDetailId"
		                label="項目"
						required="true"
		                options={this.props.detailsNeedBespoke.map((value, key) => ({label:value.get('customer_gear_name') + '-' + value.get('spec_id'), value:value})).toJS()}
		                onChange={(id, value, label) => {
		                    this.props.setValue('orderDetailId', value.get('order_detail_id'));
		                    this.props.setValue('customerGearName', label);
							this.props.setValue('batchBespokeDetail', value);
		                }}
		                validation={this.props.batchValidation.get('orderDetailId')}
		            />
				    <FieldGroup
				      id="quantity"
				      type="number"
				      label="件數"
				      value={this.props.batch.get('quantity')}
				      placeholder=""
					  required="true"
	                  onChange={(id, value) => {
	                      this.props.setValue(id, value);
	                  }}
	                  validation={this.props.batchValidation.get('quantity')}
				    />
					{this.props.fittingBatchRows}
					</Col>
			    </Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/FittingBatchEditComponent.jsx